import React from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { API } from "api";
import { UTILS } from "utils";
import { errorHandler } from "api/api/errorHandler";
import { LoaderAction } from "redux/actions";
import useGetAllZones from "../hooks/useGetAllZones";

import AppButton from "components/ui/AppButton";
import AppIcon from "components/ui/AppIcon";

const DeleteZone = ({ onClose, selectedZones, setSelectedRowsKeys }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { getAddedDeliveryZones } = useGetAllZones();
  const { isLoading } = useSelector((state) => state.LoaderReducer);
  const { selectedStore } = useSelector((state) => state.AreasReducer);

  const deleteSelectedZones = async () => {
    try {
      if (!selectedZones?.length) return;
      const zone = selectedZones[0];
      if (!zone?._id || !selectedStore?.value) return;

      dispatch(LoaderAction.setLoading(true));
      const userDetail = UTILS.getCurrentUser();

      const response = await API.deleteDistanceBaseDeliveryZone({
        storeId: selectedStore.value,
        distanceBaseDeliveryMethodId: zone._id,
        brandId: userDetail.brandId,
      });

      if (response?.success === 1) {
        UTILS.successNotification(response?.message);
        if (typeof setSelectedRowsKeys === "function") setSelectedRowsKeys([]);
        await getAddedDeliveryZones(selectedStore.value);
        onClose();
      } else {
        UTILS.errorNotification(errorHandler(response?.message));
      }
    } catch (error) {
      UTILS.errorNotification(errorHandler(error?.error?.message));
    } finally {
      dispatch(LoaderAction.setLoading(false));
    }
  };

  const count = selectedZones?.length || 0;
  const prompt =
    count === 1
      ? t("Are you sure you want to delete this zone")
      : t("Are you sure you want to delete selected zones");

  return (
    <div className="w-full bg-white p-2 sm:p-5">
      <div className="flex flex-col items-center px-8 text-center">
        <div className="mb-6 mt-6 h-44 w-44">
          <AppIcon name="trashRed" size={170} className="h-full w-full" />
        </div>
        <h1 className="text-24px font-semibold text-gray-900">{t("Delete Zone")}</h1>
        <p className="mb-0 text-3xl text-gray-500">{prompt}</p>
      </div>
      <div className="mx-auto mt-4 flex w-full max-w-[760px] items-center justify-center gap-4">
        <AppButton
          variant="secondary"
          size="lg"
          className=" w-1/2 border border-gray-400 bg-white text-4xl text-gray-500"
          onClick={onClose}
          disabled={isLoading}
        >
          {t("No, Keep It")}
        </AppButton>
        <AppButton
          variant="primary"
          size="lg"
          className="w-1/2 text-4xl"
          onClick={deleteSelectedZones}
          loading={isLoading}
        >
          {t("Yes, Delete")}
        </AppButton>
      </div>
    </div>
  );
};

DeleteZone.propTypes = {
  onClose: PropTypes.func,
  selectedZones: PropTypes.array,
  setSelectedRowsKeys: PropTypes.func,
};

export default DeleteZone;

